import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export function createGenericCell (renderItem) {
  return class GenericCell extends GridCell {
    render () {
      return (<td>{renderItem(this.props.dataItem)}</td>)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/createGenericCell.js